<template>
  <div class="rightContent">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      row-key="id"
      :cell-style="colStyle"
      @cell-mouse-enter="cellEnter"
      @cell-mouse-leave="cellLeave"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :width="50"
        align="center"
        class-name="drag_move"
      >
      <template #default="{ row, $index }">
          <div
            v-if="columnCheckedId == row.id || checkedList[$index]"
          >
            <el-checkbox
              v-model="checkedList[$index]"
              @change="cellCheckbox(row, $index)"
            ></el-checkbox>
          </div>
          <span v-else>{{ $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="this.productFirmwareVersion!=''"
          prop="title"
          label="产测名称"
          max-width="110px"
          align="left"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.factoryCommandsName"
                 class="allowSkip"
                 @click="clickShowDetail(scope.row)"
                >{{ scope.row.factoryCommandsName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="this.productFirmwareVersion!=''"
          prop="title"
          label="固件版本"
          max-width="110px"
          align="left"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.firmwareVersion"
                class="item"
          >{{ scope.row.firmwareVersion }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="this.productFirmwareVersion==''"
        prop="title"
        label="命令名称"
        max-width="110px"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.title"
            class="allowSkip"
            @click="clickAllowSkip(scope.row)">{{ scope.row.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="this.productFirmwareVersion==''"
        prop="name"
        min-width="130px"
        label="命令详情"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.name"
            >{{ scope.row.name }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="command"
        min-width="110px"
        label="命令字"
        align="left"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.command"
            placement="top"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.command">
              {{ scope.row.command }}
            </div>
          </el-tooltip>
          <span v-if="!scope.row.command">-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="station"
        label="所在工序"
        max-width="110px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.station">{{ scope.row.station.title }}</span>
          <span v-else-if="scope.row.workStation">{{ scope.row.workStation.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="执行方式"
        max-width="110px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="onlyTuya" label="产测协议" max-width="110px" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.onlyTuya">{{ scope.row.onlyTuya.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="95px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300" v-if="scope.row.firmwareVersion!=''">
            <i @click="editBtn(scope.row,'修改产测指令')" class="el-icon-edit"></i> 
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" :open-delay="300" v-if="scope.row.firmwareVersion!=''">
            <i @click="deleteBtn(scope.row)" class="el-icon-delete"></i> 
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <myDialog ref="myDialog" :title="dialogTitle" :width=winWidth
      @submitData="saveCommands" @dialogClose="loadData">
      <template slot="content">
        <el-form v-if="dialogTitle === '新增产测指令' || dialogTitle === '修改产测指令'" ref="dialogForm" :model="commandsData" :rules="dialogRules">
          <el-form-item label="产测名称：" size="small" prop="commandsName" v-if="isShowCommandsNameInput===true || productFirmwareVersion!==''">
            <el-input v-model="commandsData.commandsName" placeholder="请输入产测名称" clearable style="width: 700px"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogTitle === '新增产测指令' || dialogTitle === '修改产测指令'"
            label="所在工序："
            size="small"
            prop="commandsStation"
          >
            <el-select
                v-model="commandsData.commandsStation.code"
              placeholder="选择所在工序"
              filterable
              clearable
              style="width: 700px"
              @change="handleStationChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.factoryStationList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" size="small">
            <el-transfer v-model="commandsData.value"
                         :data="allCommands" :titles="['全部指令', '已选择']"
                         target-order="push"
                         :render-content="renderFunc"
                         filterable :filter-method="filterMethod" filter-placeholder="按名称查找" @right-check-change="choose">
              <el-button type="transfer-footer ml10" slot="right-footer" size="mini" @click="handleUp(index)" v-if="isShowCommandsNameInput==true">上移</el-button>
              <el-button type="transfer-footer" slot="right-footer" size="mini" @click="handleDown(index)" v-if="isShowCommandsNameInput==true">下移</el-button>
            </el-transfer>
          </el-form-item>
        </el-form>
        <el-form v-if="dialogTitle == '复制产测指令'" :model="copyForm" :inline="true" class="demo-form-inline" key="first">
          <el-form-item label="从" size="small">
            <el-select v-model="copyForm.from"
              placeholder="选择已有产测指令的型号" filterable clearable
              @change="productChange">
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small">
            <el-select v-model="copyForm.fromFirmWare"
              placeholder="选择型号下的固件版本" filterable clearable
             >
              <el-option
                v-for="(item, index) in pullDownData.productFirmwareList"
                :key="index" :label="item.version" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <span style="vertical-align:sub">复制产测指令到当前产品【{{this.productDetailData.code}}】【{{this.commandsSearchForm.firmwareVersion}}】</span>
        </el-form>
        <el-form v-if="dialogTitle == '产测指令排序'" :model="copyForm" :inline="true" class="demo-form-inline" key="first">
          <el-form-item :label="'将【'+ this.copyForm.commandTitel +'】移动到'" size="small">
            <el-select v-model="copyForm.to"
              placeholder="将当前指令移到选择的指令之后" filterable clearable>
              <el-option
                v-for="(item, index) in tableData"
                :key="index" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <span style="vertical-align:middle">之后</span>
        </el-form>
      </template>
    </myDialog>
    <div class="commandPage">
    <el-dialog
      title="命令详情"
      :visible.sync="dialogVisible"
      width="800px"
      @close="dialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50vh"
      class="myDialog detailDialog"
      v-dialogDrag
    >
      <ul class="ulBox clearFloat">
        <li>
          <div class="left">名称：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.title">{{
              factoryCommandDetailData.title
            }}</span>
            <span class="noValue" v-else>无</span>
          </div>
        </li>
        <li>
          <div class="left">命令详情：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.name">{{
              factoryCommandDetailData.name
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">所在工序：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.station">{{
              factoryCommandDetailData.station.title
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">执行方式：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.type">{{
              factoryCommandDetailData.type.title
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">命令字：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.command">{{
              factoryCommandDetailData.command
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">涂鸦专用：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.onlyTuya">{{factoryCommandDetailData.onlyTuya.title}}</span
            >
          </div>
        </li>
        <li class="blockLi">
          <div class="left">执行参数：</div>
          <div class="right">
            <el-input
              v-if="factoryCommandDetailDataJSON"
              class="detailTextArea"
              type="textarea"
              :readonly="true"
              :autosize="{ minRows: 1, maxRows: 8 }"
              resize="none"
              v-model="factoryCommandDetailDataJSON"
            ></el-input>
            <el-input
              v-else-if="factoryCommandDetailData.data"
              class="detailTextArea"
              type="textarea"
              :readonly="true"
              :autosize="{ minRows: 1, maxRows: 8 }"
              resize="none"
              v-model="factoryCommandDetailData.data"
            ></el-input>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">Tips：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.tips">{{
              factoryCommandDetailData.tips
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">Tips按钮：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.showButton"
              >显示</span
            >
            <span class="noValue" v-else>隐藏</span>
          </div>
        </li>
        <li>
          <div class="left">超时(秒)：</div>
          <div class="right">
            <span class="value">{{ factoryCommandDetailData.timeout }}</span>
          </div>
        </li>
        <li>
          <div class="left">超时提示：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.timeoutTips">{{
              factoryCommandDetailData.timeoutTips
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left" style="width:100px;">初始化执行：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.execInit && factoryCommandDetailData.execInit==true">是</span>
            <span class="noValue" v-else>否</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">功能说明：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.notes">{{
              factoryCommandDetailData.notes
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="closeDetail"
          >关闭</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import {
  apiProductFactoryCommandList,
  apiProductFactoryCommandSave,
  apiProductFactoryCommandEdit,
  apiProductFactoryCommandDelete,
  apiProductFactoryCommandDeleteArray,
  apiProductFactoryFirmwareCommandCopy,
  apiProductFactoryCommandMoveUp,
  apiProductFactoryCommandMoveDown,
  apiProductFactoryCommandMoveTo,
  apiProductFactoryCommandSearch,
  listByFactoryCommandsNameIsNotNull, apiProductFactoryCommandDragSort
} from "@/api/commands.js";
import { apiFactoryCommandDetail, apiFactoryStationList} from "@/api/factoryTools.js";
import { apiProductDetail } from "@/api/productModel.js";
import { apiFirmwareListVersion} from "@/api/firmwareManage.js";
import Sortable from "sortablejs";
export default {
  components: {
    myDialog,
    // eslint-disable-next-line vue/no-unused-components
    Sortable
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    commandsSearchForm: {
      type: Object,
    },
    isShowCommandsNameInput: {
      type: Boolean,
    },
    tabProductName: {
      type: String,
    }
  },
  data() {
    return {
      pullDownData: {
        productList: [],
        productFirmwareList: [],
        factoryStationList:[]
      },
      copyForm: {},
      winWidth:"850px",
      productDetailData: {},
      dialogVisible: false,
      factoryCommandDetailData: {},
      tableData: [],
      allCommands: [],
      data:[],
      labelWidth: this.$store.state.labelWidth,
      dialogTitle: "",
      //配置指令弹出框值
      commandsData: {
        value:[],
        commandsName:"",
        commandsStation:{}
      },
      dialogRules: {
        commandsName: [
          { required: true, message: "产测名称不能为空！", trigger: "blur" },
        ],
        commandsStation: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || !value.code) {
                callback(new Error("所在工序不能为空！"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      productFirmwareVersion: "",
      productFactoryCommandId:"",
      commandId:"",
      //穿梭框右侧列表项排序
      sort:"",
      //穿梭框右侧列表被选中的项
      item:"",
      //穿梭框右侧列表被选中项的下标值
      index:"",
      factoryCommandDetailDataJSON:"",
      columnCheckedId: '',
      multipleSelection: [], //table多选数据
      multipleSelectionId: [], //table多选数据
      checkedList: [], //table多选选中数据
    };
  },
  mounted () {
    this.rowDrop();
    this.getFactoryStationList();
  },
  methods: {
    handleStationChange() {
      this.$nextTick(() => {
        const form = this.$refs && this.$refs.dialogForm;
        if (form) {
          form.validateField && form.validateField('commandsStation');
        }
      });
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
        if (this.multipleSelection.length == this.tableData.length) {
          this.multipleSelection.forEach((item, index) => {
          this.checkedList[index] = true;
          this.multipleSelectionId[index] = item.id;
        })
        }
        if (this.multipleSelection.length == 0) {
          this.checkedList = [];
          this.multipleSelection = [];
          this.multipleSelectionId =[];
        }
        this.$emit('selectList', this.multipleSelection)
    },
    //鼠标移入表格当前行
    cellEnter(row) {
      this.columnCheckedId = row.id
    },
    // 鼠标移出表格当前行
    cellLeave() {
      this.columnCheckedId = ''
    },
    // 选中与否 塞数据
    cellCheckbox(row, index) {
      if (this.checkedList[index]) {
        this.checkedList[index] = true;
        this.multipleSelection[index] = row;
        this.multipleSelectionId[index] = row.id;
      } else {
        this.checkedList[index] = false;
        this.multipleSelection.splice(index,1);
        this.multipleSelectionId.splice(index,1);
      }
    },

    renderFunc(h,option){
      return <span title={option.tips}>{option.label}</span>
    },
    moveTo(event, row) {
      this.copyForm = {};
      this.dialogTitle = "产测指令排序";
      this.copyForm.id = row.id;
      this.copyForm.commandTitel = row.title;
      this.winWidth="580px";
      this.$refs.myDialog.dialogVisible = true;
    },
    dialogClose() {
      if (this.dialogTitle == "新增产测指令" || this.dialogTitle == "修改产测指令") {
        document.querySelectorAll(".el-dialog").forEach((item) => {
          setTimeout(() => {
            item.style.left = "0";
            item.style.top = "0";
          }, 500);
        });
      } else {
        this.productDetailData = {};
        this.copyForm = {};
      }
    },
    async copyBtn() {
        const res1 = await apiProductDetail({
          id: this.tabPaneValue
        });
        if (res1.code == 0) {
          const res = await listByFactoryCommandsNameIsNotNull({
            productType: res1.data.productType.code
          });
          if (res.code == 0) {
            this.pullDownData.productList = res.data;
            this.productDetailData = res1.data;
          }
          this.dialogTitle = "复制产测指令";
          this.winWidth="580px";
          this.$refs.myDialog.dialogVisible = true;
        }
    },
    // 产品型号选择发生改变是
    productChange(value) {
      this.$set(this.copyForm, "fromFirmWare", null);
      this.pullDownData.productFirmwareList = [];
      if (value) {
        this.apiFirmwareList(value);
        
      }
    },
    // 产品型号中的固件版本下拉
    async apiFirmwareList(tabProductId) {
      const res = await apiFirmwareListVersion({
        productId: tabProductId
      });
      if (res.code == 0) {
        this.pullDownData.productFirmwareList = res.data;
      }
    },
    //根据选择的多个结果进行删除
    async deleteArrayBtn(){
      let name = this.tabProductName;
      if(this.multipleSelectionId.length == 0){
        this.$message.error("请选择需要删除的指令");
        return;
      }
        // 删除
        const h = this.$createElement;
        this.$msgbox({
          title: `批量删除产品产测指令`,
          message: h("div", null, [
            h("span", null, `请输入需要删除的产品的名称:【`),
            h("i", { style: "color: var(--themeColor)" }, name),
            h("span", null, `】以确认删除！`)
          ]),
          showCancelButton: true,
          confirmButtonText: `确认`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showInput: true,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (instance.inputValue === name) {
                done()
              } else {
                this.$message({
                  type: "warning",
                  message: `输入错误，请重新输入或取消！`
                })
              }
            } else {
              done()
            }
          }
        }).then(async () => {
          var productFactoryCommandId = this.multipleSelectionId.filter(function (s) {
              return s && s.trim(); 
          });
          const res = await apiProductFactoryCommandDeleteArray({
            id:this.tabPaneValue,
            productFactoryCommandId:productFactoryCommandId
          });
          if (res.code == 0) {
            this.loadData();
            this.checkedList = [];
            this.multipleSelection = [];
            this.multipleSelectionId =[];
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
          
        })
    },
    async deleteBtn(row){
      let name ="";
      if(row != null){
        this.productFactoryCommandId = row.id;
        name = row.factoryCommandsName;
      }else{
        this.$message.error("请选择需要删除的指令");
        return;
      }
      
        // 删除
        const h = this.$createElement;
        this.$msgbox({
          title: `删除产品产测指令`,
          message: h("div", null, [
            h("span", null, `请输入产测指令名称:【`),
            h("i", { style: "color: var(--themeColor)" }, name),
            h("span", null, `】以确认删除！`)
          ]),
          showCancelButton: true,
          confirmButtonText: `确认`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showInput: true,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (instance.inputValue === name) {
                done()
              } else {
                this.$message({
                  type: "warning",
                  message: `输入错误，请重新输入或取消！`
                })
              }
            } else {
              done()
            }
          }
        }).then(async () => {
          const res = await apiProductFactoryCommandDelete({
            id:this.productFactoryCommandId,
          });
          if (res.code == 0) {
            this.loadData();
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
          
        })
    },
    // 所在工序下拉数据
    async getFactoryStationList() {
      const res = await apiFactoryStationList();
      if (res.code == 0) {
        this.pullDownData.factoryStationList = res.data;
      }
    },
    async editBtn(row,dialogTitle) {
      if(row != null){
        this.productFactoryCommandId = row.id;
        this.isShowCommandsNameInput=true;
      }else{
        this.productFactoryCommandId = 0;
      }
      // if(this.commandsSearchForm.firmwareList=="" || this.commandsSearchForm.firmwareList==null){
      //   this.$message.error("请先到固件管理中新增固件");
      //   return;
      // }
      const res = await apiProductFactoryCommandList({
        id: this.tabPaneValue,
        productFactoryCommandId:this.productFactoryCommandId,
        firmwareId: this.commandsSearchForm.firmwareList,
      });
      if (res.code == 0) {
        this.allCommands.length=0;
        this.data = res.data.factoryCommands;
        // 全部指令
        this.data.forEach((item,index) => {
          var execInit="";
          if(item.execInit){
            execInit="是";
          }else{
            execInit="否";
          }
          var station = item.station==undefined ? item.workStation.name : item.station.title;
          this.allCommands.push({
            index: index,
            key: item.id,
            label: item.name,
            tips:"工位："+station+"，产测协议："+"("+item.command+")"+item.onlyTuya.title+"，执行方式："+item.type.title+"，初始化执行："+execInit+"，执行参数："+ (item.data==undefined?'':item.data)
          });
        });
        // 已选择的指令
        this.commandsData.value = res.data.productCommands;
        this.commandsData.commandsName = res.data.productCommandsName;
        this.commandsData.commandsStation = res.data.productCommandsStation || {};
        console.log(this.commandsData);
        // 打开弹框
        this.dialogTitle = dialogTitle;
        this.winWidth="850px";
        this.$refs.myDialog.dialogVisible = true;
      }
      // this.$parent.editor_commands=this.editor;
    },
    closeDetail() {
        this.dialogVisible = false;
    },
    // 表格列命令名称点击
    async clickAllowSkip(row) {
      this.factoryCommandDetailDataJSON="";
      const res = await apiFactoryCommandDetail({
        id: row.commandId,
      });
      if (res.code == 0) {
        this.dialogVisible = true;
        this.factoryCommandDetailData = res.data;
      }
    },
    clickShowDetail(row){
      this.dialogVisible = true;
      this.factoryCommandDetailData = row;
      if(row.data==undefined || row.data==null){
        this.factoryCommandDetailDataJSON = "";
      }else{
        var jsonObject = JSON.parse(row.data);
        this.factoryCommandDetailDataJSON= JSON.stringify(jsonObject,null,4);
      }
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    // 上移
    moveUpCommand(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移命令", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductFactoryCommandMoveUp({
          id: row.id,
        });
        if (res.code == 0) {
          this.loadData();
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownCommand(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移命令", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductFactoryCommandMoveDown({
          id: row.id,
        });
        if (res.code == 0) {
          this.loadData();
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    async loadData() {
      // if(this.commandsSearchForm.firmwareList=="" || this.commandsSearchForm.firmwareList==null){
      //   this.$message.error("请先到固件管理中新增固件");
      //   return;
      // }
      const res = await apiProductFactoryCommandSearch({
        id: this.tabPaneValue,
        firmwareId: this.commandsSearchForm.firmwareList,
      });
      if (res.code == 0) {
        this.tableData = res.data;
        if(res.data[0] !=null){
          this.productFirmwareVersion = res.data[0].firmwareVersion;
          this.commandId=res.data[0].commandId;
        }else{
          this.productFirmwareVersion = '';
          this.commandId='';
        }
      }
      this.$emit('updatePageData',this.commandId);
    },
    async saveCommands() {
      if (this.dialogTitle == '新增产测指令' || this.dialogTitle == '修改产测指令') {
        // 校验必填项，不通过则不允许提交
        const form = this.$refs && this.$refs.dialogForm;
        if (form) {
          const valid = await new Promise(resolve => {
            form.validate(valid => resolve(valid));
          });
          if (!valid) {
            return;
          }
        }
        // 保存修改
        const h = this.$createElement;
        this.$msgbox({
          title: `修改产测指令`,
          message: h("div", null, [
            h("span", null, `请输入产品型号:【`),
            h("i", { style: "color: var(--themeColor)" }, this.tabProductName),
            h("span", null, `】以确认修改！`)
          ]),
          showCancelButton: true,
          confirmButtonText: `修改`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showInput: true,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (instance.inputValue === this.tabProductName) {
                done()
              } else {
                this.$message({
                  type: "warning",
                  message: `输入错误，请重新输入或取消！`
                })
              }
            } else {
              done()
            }
          }
        }).then(async () => {
          //判断是配置指令还是新增指令，TRUE为新增指令
          if(this.isShowCommandsNameInput == true){
            var stationCode = this.commandsData.commandsStation?this.commandsData.commandsStation.code:'';
            const res = await apiProductFactoryCommandEdit({
              id: this.tabPaneValue,
              commands: this.commandsData.value,
              firmwareId: this.commandsSearchForm.firmwareList,
              commandsName: this.commandsData.commandsName,
              commandsStation: stationCode,
              productFactoryCommandId:this.productFactoryCommandId
            })
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          }else{
            const res = await apiProductFactoryCommandSave({
              id: this.tabPaneValue,
              commands: this.commandsData.value
            })
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          }
        })
      } else if (this.dialogTitle == '复制产测指令') {
        if(this.copyForm.from==null){
          this.$message({
                  type: "warning",
                  message: `请选择产品`
                });
                return;
        }
        if(this.copyForm.fromFirmWare==null){
          this.$message({
                  type: "warning",
                  message: `请选择固件`
                });
                return;
        }
        const res = await apiProductFactoryFirmwareCommandCopy({
            from: this.copyForm.from,
            fromFirmWare:this.copyForm.fromFirmWare,
            to: this.tabPaneValue,
            toFirmWare: this.commandsSearchForm.firmwareList,
          });
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      } else if (this.dialogTitle == '产测指令排序') {
        const res = await apiProductFactoryCommandMoveTo({
          id: this.copyForm.id,
          to: this.copyForm.to
        });
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      }
    },
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      const _this = this;
      let tempName = '';
      let tempId = '';
      let firmwareVersion ='';
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".el-table__row",
        animation:500,
        handle: ".drag_move",
        onStart(evt) {
          const index=evt.oldIndex;
          const IndexRow  = _this.tableData.slice(index,index+1)[0];
          tempId = IndexRow.id;
          firmwareVersion = IndexRow.firmwareVersion;
          if(firmwareVersion != ''){
            tempName = IndexRow.factoryCommandsName;
          }else{
            tempName = IndexRow.title;
          }
        },
        onEnd ({ newIndex, oldIndex }) {
          if(newIndex == oldIndex){
            return;
          }
          
          let newIndexTemp = newIndex + 1;
          let oldIndexTemp = oldIndex + 1;
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          
          _this.$confirm('确定将【'+ tempName +'】从第【'+oldIndexTemp+'】行排序到第【'+newIndexTemp+'】行', "排序工具", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const res = await apiProductFactoryCommandDragSort({
              id: tempId,
              sortNum: newIndex
            });
            if (res.code == 0) {
              await _this.loadData();
              _this.$message({
                message: "排序成功",
                type: "success",
              });
            }else {
              _this.loadData();
            }
          }).catch(()=>{
            _this.loadData();
          });

          // _this.sortableResult = JSON.stringify(_this.tableData);
        }
      })
    },
    colStyle({columnIndex}) {
      if (columnIndex ==0) {
        return 'cursor: move;'
      }
    },
    //穿梭框右侧选项选中事件
    choose(value){
      let self = this;
      self.item = value;
    },
    //穿梭框右侧上移事件
    handleUp(item,index){
      let self = this;
      item = self.item; //选中值
      if(item.length == 1){
        //选中值得下标
        self.commandsData.value.find((val, indexs, arr) => {
          if(val == item){
            index = indexs;
            arr;
          }
        });
        if(index == 0){
          self.$message("没有上移的位置了！");
          return;
        }
        //改变数组顺序
        let changeItem = JSON.parse(JSON.stringify(self.commandsData.value[index - 1]));
        self.commandsData.value.splice(index - 1, 1);
        self.commandsData.value.splice(index, 0, changeItem);
      }else{
        self.$message("只能选中一条数据进行上下移动");
        return;
      }
    },
    //穿梭框右侧下移事件
    handleDown(item,index){
      let self = this;
      item = self.item;
      if(item.length == 1){
        self.commandsData.value.find((val, indexs, arr) =>{
          if(val == item){
            index = indexs;
            arr;
          }
        });
        if(index == self.commandsData.value.length-1){
          self.$message("没有下移的位置了！");
          return;
        }
        //改变数组顺序
        let changeItem = JSON.parse(JSON.stringify(self.commandsData.value[index]));
        self.commandsData.value.splice(index,1);
        self.commandsData.value.splice(index + 1, 0, changeItem);

      }else{
        self.$message("只能选中一条数据进行上下移动");
        return;
      }
    },
  }
};
</script>
<style scoped>
   /*.rightContent >>> .el-transfer {*/
   /*  margin: 10px;*/
   /*}*/
   .rightContent >>> .el-transfer-panel {
     width: 304px;
   }
   .rightContent >>> .el-transfer-panel__body {
     height: 420px;
   }
   .rightContent >>> .el-transfer-panel__list {
     height: 370px;
   }

   .detailTextArea >>> .el-textarea__inner {
    border: 0;
    cursor: auto;
    padding: 3px 0;
  }
   .ml10 {margin-left: 90px;}
</style>
